import { useNavigate } from 'react-router-dom'

import PaveLogo from 'assets/images/pave-logo.svg'
import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { SIZE } from 'designSystem/foundations/constants/size'

export default function NotFoundPage() {
  const navigate = useNavigate()

  const goHome = () => navigate('/')

  return (
    <PDSBox height="100vh">
      <PDSBox marginTop={SIZE.s24} marginLeft="3.5rem">
        <img
          src={PaveLogo}
          alt="Pave Logo"
          width={89}
          height={48}
          onClick={goHome}
          style={{ cursor: 'pointer' }}
        />
      </PDSBox>
      <PDSFlexBox marginTop="10%" justifyContent="center">
        <PDSFlexBox
          marginLeft={SIZE.s72}
          flexDirection="column"
          alignItems="center"
        >
          <PDSHeader>Oops! Page not found.</PDSHeader>
          <PDSBox marginTop={SIZE.s16}>
            <PDSText>Sorry, we cannot find this page.</PDSText>
          </PDSBox>
          <PDSButton
            marginTop={SIZE.s32}
            text="Go Back Home"
            onClick={goHome}
          />
        </PDSFlexBox>
      </PDSFlexBox>
    </PDSBox>
  )
}
